import React from "react";
import { Button } from "src/components/buttons";
import CustomModal from "src/components/modals";
import TypeFormEmbed from "../typeforms";

const RecapSection: React.FC = () => {
  const [isVisibleTypeForm, setIsVisibleTypeForm] = React.useState(false);
  return (
    <div className="justify-center items-center flex-col flex bg-gradient-to-t from-[#05132D] to-[#052643] noise-background-image-top">
      <div className="flex items-center justify-center mt-[5rem] mx-auto text-center p-6">
        <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2]">
         
       

          Participez au lancement officiel de <i className="app-title-italic text-[#20E87F] text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2]">DOOR <br/>le Cloud Souverain,</i>, 
           à Abidjan le 24 avril  <br/> et à Dakar le 29 avril.
        </h1>
      </div>
      <Button className="mb-[5rem] mt-[2rem] flex xs:h-[40px] sm:h-[40px] md:h-[4px] lg:h-[45px] xl:h-[45px] xs:p-[8px] sm:p-[8px]  md:p-[15px] lg:p-[15px] xl:p-[15px] justify-center items-center gap-[8px] rounded-[12px] [background:var(--main-gradient,linear-gradient(90deg,#145BF0_0%,#1DC66D_100%))]"
      onClick={() => setIsVisibleTypeForm(true)}>
        PARTICIPEZ <i className="bi bi-arrow-right"></i>
      </Button>
      {isVisibleTypeForm && (
        <CustomModal
          isOpen={isVisibleTypeForm}
          onClose={() => setIsVisibleTypeForm(false)}
          title=""
        >
          <TypeFormEmbed />
        </CustomModal>
      )}
    </div>
  );
};

export default RecapSection;
